import React from "react";
import { AppBar, Typography, Toolbar, useMediaQuery, useTheme } from '@mui/material';

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); 

  return (
    <AppBar
      position="static"
      sx={{
        bgcolor: "#002fa7",
        px: 2,
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: isMobile ? '56px' : '64px',
          textAlign: 'center',
        }}
      >
        <Typography
          variant={isMobile ? "subtitle2" : "h6"}
          color="inherit"
          sx={{ fontSize: isMobile ? '0.85rem' : '1.25rem' }}
        >
          मातोश्री शासकीय आर्थिकदृष्टया मागासवर्गीय मुलांचे वसतिगृह, उंटावद  ता. शहादा जि. नंदुरबार
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
